import { Component, input } from '@angular/core';

@Component({
  selector: 'syn-checkbox-title',
  templateUrl: './checkbox-title.component.html',
})
export class CheckboxTitleComponent {
  readonly title = input<string>(undefined);
}
